export default __webpack_public_path__ + "static/media/viviana-gavilanes.487e45b8.png";